import React from 'react';
import '../styles/Goa.css';
import logo from "../assets/logo3.webp";
import { Link, useLocation } from "react-router-dom";
import goaData from '../data/goa.json';
import goaBanner from '../assets/goabeach.png';

const imageMap = {
  '../assets/bagabeach.png': require('../assets/bagabeach.png'),
  '../assets/palelobeach.png': require('../assets/palelobeach.png'),
  '../assets/anjunabeach.png': require('../assets/anjunabeach.png'),
  '../assets/calungutebeach.png': require('../assets/calungutebeach.png'),
  '../assets/colvabeach.png': require('../assets/colvabeach.png'),
  '../assets/vagatorbeach.png': require('../assets/vagatorbeach.png'),
  '../assets/morjimbeach.png': require('../assets/morjimbeach.png'),
  '../assets/arambolbeach.png': require('../assets/arambolbeach.png'),
  '../assets/butterflybeach.png': require('../assets/butterflybeach.png'),
  '../assets/candolimbeach.png': require('../assets/candolimbeach.png'),
  '../assets/cabana.png': require('../assets/cabana.png'),
  '../assets/titos.png': require('../assets/titos.png'),
  '../assets/mambos.png': require('../assets/mambos.png'),
  '../assets/sinq.png': require('../assets/sinq.png'),
  '../assets/lpk.png': require('../assets/lpk.png'),
  '../assets/hilltop.png': require('../assets/hilltop.png'),
  '../assets/cavala.png': require('../assets/cavala.png'),
  '../assets/toro.png': require('../assets/toro.png'),
  '../assets/chronicle.png': require('../assets/chronicle.png'),
  '../assets/Cohiba.png': require('../assets/Cohiba.png'),
  '../assets/thalassa.png': require('../assets/thalassa.png'),
  '../assets/artjuna.png': require('../assets/artjuna.png'),
  '../assets/eva.png': require('../assets/eva.png'),
  '../assets/sakana.png': require('../assets/sakana.png'),
  '../assets/gunpowder.png': require('../assets/gunpowder.png'),
  '../assets/baba.png': require('../assets/baba.png'),
  '../assets/chocolatti.png': require('../assets/chocolatti.png'),
  '../assets/pousada.png': require('../assets/pousada.png'),
  '../assets/curlies.png': require('../assets/curlies.png'),
'../assets/taj.png': require('../assets/taj.png'),
'../assets/leela.png': require('../assets/leela.png'),
'../assets/itc.png': require('../assets/itc.png'),
'../assets/alila.png': require('../assets/alila.png'),
'../assets/cidade.png': require('../assets/cidade.png'),
'../assets/w.png': require('../assets/w.png'),
'../assets/planet.png': require('../assets/planet.png'),
'../assets/fairfield.png': require('../assets/fairfield.png'),
'../assets/acron.png': require('../assets/acron.png'),
'../assets/lavie.png': require('../assets/lavie.png')

};

const Goa = () => {
      const location = useLocation();
  return (
    <>
     <header className="contact-header over-banner">
        <div className="contact-logo">
          <img src={logo} alt="Tourly Logo" />
        </div>
        <nav className="contact-nav">
          <Link to="/">Home</Link>
          <Link to="/packages">Packages</Link>
          <div className="contact-dropdown">
<a href="#" className={`contact-dropbtn ${location.pathname === '/goa' ? 'active-link' : ''}`}>Destinations</a> 
<div className="contact-dropdown-content">
              <Link to="/goa">Goa</Link>
              <Link to="/kerala">Kerala</Link>
              <Link to="/rajasthan">Rajasthan</Link>
              <Link to="/himachal">Himachal Pradesh</Link>
              <Link to="/uttarakhand">Uttarakhand</Link>
                              <Link to="/abu">Abu Dhabi</Link>
                <Link to="/dubai">Dubai</Link>
            </div>
          </div>
            <Link to="/hotels">Hotels</Link>
        <Link to="/contact-us">Contact Us</Link>
          
        </nav>
          <Link to="/booknow">
        <button className="contact-book-btn">Book Now</button>
                    </Link>
      </header>
    <div className="goa-page">
      <div className="goa-hero">
        <div className="goa-hero-overlay">
          <h1>Explore Goa</h1>
          <p>Sun, Sand, Sea – Your perfect beach escape</p>
        </div>
        <img src={goaBanner} alt="Goa Banner" className="goa-hero-img" />
      </div>

      <section className="goa-info">
        <h2>Welcome to Goa</h2>
        <p>
          Goa is India’s top beach destination known for its beautiful coastline, vibrant nightlife, Portuguese architecture,
          seafood, and spiritual experiences. Whether you’re looking for relaxation or adventure, Goa has it all.
        </p>
      </section>

      {Object.entries(goaData).map(([sectionTitle, items]) => (
        <section className="goa-section" key={sectionTitle}>
          <h2>{formatTitle(sectionTitle)}</h2>
          <div className="goa-cards-container">
            {items.map((item, index) => (
              <div className="goa-card" key={index}>
             < img
                  src={imageMap[item.image] || item.image}
                  alt={item.name}
                />
                <h3>{item.name}</h3>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
    </>
  );
};

const formatTitle = (key) => {
  switch (key) {
    case 'Beaches': return 'Beaches';
    case 'Clubs': return 'Clubs';
    case 'Cafes': return 'Cafes';
    case 'Hotels': return 'Hotels & Resorts';
    case 'Forts': return 'Forts';
    default: return key;
  }
};

export default Goa;
